import { tabsAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

var _a = createMultiStyleConfigHelpers(tabsAnatomy.keys), definePartsStyle = _a.definePartsStyle, defineMultiStyleConfig = _a.defineMultiStyleConfig;
var baseStyle = definePartsStyle({
    tablist: {
        '.chakra-tabs__tab': {
            py: 3,
        },
    },
    tab: {
        _selected: {
            borderBottom: '3px solid',
            color: 'primary.900',
            pt: '11.5px',
        },
        _hover: {
            bg: 'neutrals.100',
            borderBottom: '1px solid',
            borderColor: 'neutrals.300',
            pt: '11.5px',
            mb: 0
        }
    }
});
var tabsTheme = defineMultiStyleConfig({ baseStyle: baseStyle });

export { tabsTheme };
//# sourceMappingURL=tabs.js.map
